import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/conditions',
  	  method: 'get',
        params
  	})
  }

export function show(id) {
    return request({
      url: `/conditions/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/conditions',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/conditions/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/conditions/${id}`,
      method: 'delete',
    })
  }
